<template>
  <SoDialog
    v-model="value"
    :max-width="1200"
    card-title="An Energy Supplier's Responsibilities"
    data-testid="suppliers-responsibly-modal"
  >
    <div class="suppliers-responsibly__grid">
      <v-img :src="gasImgSrc" />
      <section class="ml-2">
        So Energy is responsible for:
        <div class="mb-4">
          <ul class="ml-4">
            <li>The regulator</li>
            <li>The governor pipe</li>
            <li>The Meter unit</li>
          </ul>
        </div>
        The customer is responsible for:
        <div class="mb-4">
          <ul class="ml-4">
            <li>Internal piping</li>
            <li>Meter box & key</li>
          </ul>
        </div>
        The GT is responsible for:
        <div class="mb-4">
          <ul class="ml-4">
            <li>Gas supply pipe</li>
            <li>Emergency control valve</li>
          </ul>
        </div>
      </section>
      <v-img :src="elecImgSrc" />
      <section class="ml-2">
        So Energy is responsible for:
        <div class="mb-4">
          <ul class="ml-4">
            <li>Meter tails</li>
            <li>Isolation switch</li>
            <li>The Meter unit</li>
          </ul>
        </div>
        The customer is responsible for:
        <div class="mb-4">
          <ul class="ml-4">
            <li>Meter board</li>
            <li>Internal electrics</li>
            <li>Meter box and key</li>
          </ul>
        </div>
        The DNO is responsible for:
        <div class="mb-4">
          <ul class="ml-4">
            <li>Service Head/Meter fuse</li>
            <li>Service cable</li>
          </ul>
        </div>
      </section>
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoDialog from "@/components/SoDialog.vue"

  export default defineComponent({
    components: {
      SoDialog,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        elecImgSrc:
          "https://soenergy-so-watt.s3.eu-west-2.amazonaws.com/electricity-meter-responsibilities.png",
        gasImgSrc:
          "https://soenergy-so-watt.s3.eu-west-2.amazonaws.com/gas-meter-responsibilities.png",
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
  })
</script>

<style scoped>
  .suppliers-responsibly__grid {
    display: grid;
    grid-template-columns: 8fr 4fr;
    gap: 8px;
  }
</style>
